import ruLocale from 'element-ui/lib/locale/lang/ru-RU' //引入element语言包
const ru = {
  Login: {
    ToLogin: 'Регистрация',
    PhoneLogin: 'Номер мобильного',
    EmailLogin: 'Почтовый ящик',
    PhonePlaceholder: 'Пожалуйста, введите номер телефона.',
    EmailPlaceholder: 'Enter email',
    Code: 'Код проверки',
    and: 'А',
    BeforeText: 'Создание учетной записи означает ваше согласие и соблюдение',
    UserAgreement: 'Пользовательское соглашение',
    privacy: 'Политика конфиденциальности',
    errorMessage: 'Ошибка кода проверки',
    readTitle: 'Читайте и соглашайтесь со следующим соглашением',
    readBefore: 'Чтобы обеспечить безопасность ваших персональных данных, сначала прочтите и согласитесь.',
    cancel: 'Отменить',
    agree: 'Согласен и продолжается',
    error1:'Введите действительный адрес почтового ящика',
    error2:'Пожалуйста, введите правильный номер телефона.',
    error3:'Введите код проверки.',
    success:'Регистрация завершена'
  },
  ...ruLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default ru;
